module.exports = __webpack_public_path__ + "static/img/news5.2f80679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news5.png
// module id = wBGA
// module chunks = 1